import storage from 'src/components/Core/Utils/storage'

import { AccountInfo } from '@azure/msal-common'
import { IPublicClientApplication } from '@azure/msal-browser'

export const signOutClickHandler = (
  instance: IPublicClientApplication,
  accounts: AccountInfo[],
): void => {
  // All keys outside the store object will be deleted on the logout
  Object.values(storage.keys.main).forEach(value => {
    if (typeof value === 'string') sessionStorage.removeItem(value)
  })
  Object.values(storage.keys.onboarding).forEach(value => {
    if (typeof value === 'string') sessionStorage.removeItem(value)
  })

  const logoutRequest = {
    account: instance.getAccountByHomeId(accounts?.[0]?.homeAccountId),
    postLogoutRedirectUri: window.location.origin,
  }
  instance.logoutRedirect(logoutRequest)
}
